import ModalProvider from './Modal';

export default ModalProvider;
